import React, {useState, useEffect} from 'react'

import "./Users.css"
import Sidebar from "../../shared/sidebar/Sidebar"
import Navbar from "../../shared/navbar/Navbar"
import DataTable from "../../shared/datatable/DataTable"
import axios from 'axios'
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import UserEditor from './Editor'
import { format } from 'fecha';
import ErrorMessages from '../../shared/errormessages/ErrorMessages';

const Users = () => {

  const [editorState, setEditorState] = useState({open: false, data: null})
  const [pageState, setPageState] = useState({ loading: false})
  const [pageData, setPageData] = useState({
      status: "",
      data: [],
      total: 0
  })

  const [errors, setErrors] = useState("")
  const [search, setSearch] = useState("")
  const [managerType, setManagerType] = useState(0)
  const [gender, setGender] = useState(0)

  useEffect(()=>{
    if(pageState.loading == false){
      axios.get('/users/getlist?search=' + search + '&type=' + managerType + '&gender=' + gender)
        .then(function (response) {
          if(response.data.status == "success"){
            setErrors("");
            setPageData(response.data);
            setPageState({loading: true});
          }
          else{
            setErrors(response.data.message);
          }
        })
        .catch(function (error) {
          setErrors(error.message);
        });
    }
  })

  const model = {
    columns: [
      {
        field: "FullName",
        headerName: "User",
        width: 150,
        renderCell: (params) => {
          return (
            <div className="cellWithImg" onClick={()=> handleOnCellClick(params)}>
              <img className="cellImg" src={axios.defaults.baseURL + '/' + params.row.Photo} alt="avatar" />
              <a className="cellWithLink">{params.row.FullName}</a>
            </div>
          );
        },
      },
      {
          field: "Age",
          headerName: "Gender/Age",
          renderCell: (params) => {
              return (
                <div className="userDetail">
                  {params.row.Gender == 1 && "Male"}
                  {params.row.Gender == 2 && "Female"}
                  {params.row.Gender == 3 && "Other"}
                  {params.row.Gender == 4 && "Prefer not to disclose"}
                  <span> {params.row.Age}</span>
                </div>
              );
            },
        },
      {
        field: "Email",
        headerName: "Email",
        width: 150,
      },
      {
        field: "RoleName",
        headerName: "Role",
        width: 100,
      },
      {
        field: "IsLoggedIn",
        headerName: "Logged In",
        width: 100,
        renderCell: (params) => {
          return (
            <div className={`cellWithStatus ${params.row.IsLoggedIn}`}>
             <span>{params.row.IsLoggedIn && "YES"}{!params.row.IsLoggedIn && "NO"}</span>
            </div>
          );
        },
      },
        {
          field: "Designation",
          headerName: "Designation",
          width: 150,
        },
        {
          field: "Experience",
          headerName: "Experience",
          width: 100,
        },
        {
          field: "ManagerType",
          headerName: "Manager Type",
          width: 120,
          renderCell: (params)=>{
            return(
              <span>{params.row.ManagerType == 1 ? "FTM" : (params.row.ManagerType == 2 ? "MM" : "OTR")}</span>
            );
          }
        },
        {
          field: "Tenure",
          headerName: "Tenure",
          width: 80,
        },
        {
          field: "ReportSent",
          headerName: "Report Sent",
          width: 100,
          renderCell: (params) => {
              return (
                <div className={`cellWithStatus ${params.row.ReportSent}`}>
                 <span>{params.row.reportsent && params.row.ReportSentOn}</span>
                 <span>{!params.row.ReportSent && "NO"}</span>
                 {params.row.ReportSent && <DownloadForOfflineIcon/>}
                 
                </div>
              );
            },
        },
        {
          field: "Nationality",
          headerName: "Nationality",
          width: 100,
        },
        {
          field: "Location",
          headerName: "Location",
          width: 100,
        },
        {
          field: "Function",
          headerName: "Function",
          width: 100,
        },
     
      {
        field: "ModifiedBy",
        headerName: "Modified By",
        width: 120,
      },
      {
        field: "ModifiedOn",
        headerName: "Modified On",
        width: 150,
        renderCell: (params)=>{
          return(
            params.row.ModifiedOn &&
            <span>{format(new Date(params.row.ModifiedOn), 'DD/MM/YYYY HH:mm')}</span>
          );
        }
      },
    ],
    modulename: "Users"
  };

  const handleOnCellClick = (params) => {
    setEditorState({ open: true, data: params.row});
  };

  return (
    <div className="list">
      <Sidebar/>
      <div className="listContainer">
        <Navbar title={model.modulename}/>
        <ErrorMessages message={errors}/>
        {
          editorState.open == true ? 
          <UserEditor data={editorState} setEditorState={setEditorState} setPageState={setPageState} setErrors={setErrors} /> : 
          <DataTable  {...model} rows={pageData.data} checkboxSelection={true} setEditorState={setEditorState} setPageState={setPageState} setErrors={setErrors} 
          setGender={setGender} setSearch={setSearch} setManagerType={setManagerType}
          />
        }
      </div>
    </div>
  )
}

export default Users